import { createMiddlewareFromEventsMap } from '@noths/polaris-client-next-redux';

import { GAEventsMap as breadcrumbsGAEventsMap } from 'src/components/molecules/Breadcrumb';
import { GAEventsMap as favouritesGAEventsMap } from 'src/components/organisms/Favourites/tracking/eventsMap';
import { GAEventsMap as filterGAEventsMap } from 'src/components/organisms/Filter';
import { GAEventsMap as filterMenuGAEventsMap } from 'src/components/organisms/FilterMenu';
import { GAEventsMap as linkCarouselGAEventsMap } from 'src/components/organisms/LinkCarousel';
import { GAEventsMap as noSearchResultsGAEventsMap } from 'src/components/organisms/NoSearchResultsGuard';
import { GAEventsMap as productGAEventsMap } from 'src/components/organisms/ProductPage/tracking/eventsMap';
import { ReduxApplicationState } from './combinedReducer';
import { GAEventsMap as navigationGAEventsMap } from './navigation';
import { GAEventsMap as productsGAEventsMap } from './products';

export const eventsMap = {
  ...breadcrumbsGAEventsMap,
  ...favouritesGAEventsMap,
  ...filterGAEventsMap,
  ...filterMenuGAEventsMap,
  ...navigationGAEventsMap,
  ...noSearchResultsGAEventsMap,
  ...productsGAEventsMap,
  ...productGAEventsMap,
  ...linkCarouselGAEventsMap,
};

export const GAMiddleware = createMiddlewareFromEventsMap<ReduxApplicationState>(eventsMap);
